import React, { useContext, useState } from "react";
import loader from '../images/spinner_purple.gif';
import { ViewsContext } from "../context/ViewsContext";
import { Redirect } from "react-router-dom";
import axios from 'axios';
import { ConfigurationContext } from '../context/ConfigurationContext';
import REACT_APP_API_BASE_URL from '../index.js';


const LoadingView = () => {
  const { views, setViews } = useContext(ViewsContext);
  const { configurations, setConfigurations } = useContext(ConfigurationContext);
  const [state, setState] = useState({ loading: true, viewsLoading: true, error: false, redirect: false });

  React.useEffect(()=>{
    if(!configurations){
      axios
        .get( REACT_APP_API_BASE_URL + 'configuration' )
        .then(response => {
          setConfigurations({ ...configurations, items: response.data });
          setState({ ...state, loading: false, redirect: true });
        })
        .catch( err => {
          setState({ ...state, loading: false, error: true });
        });
    }

    if(!views && configurations) {
      axios
        .get( REACT_APP_API_BASE_URL + 'views' )
        .then(response => {
          setViews({ ...views, items: response.data });
          setState({ ...state, viewsLoading: false, redirect: true });
        })
        .catch( err => {
          setState({ ...state, viewsLoading: false, error: true });
        });
    }

  }, [configurations, setConfigurations, setViews, state, views]);


  if (state.redirect && !state.viewsLoading && !state.loading) {
    return <Redirect to='/start'/>;
  }

  return (
    <div>
      {state.loading || state.viewsLoading  ? <div className={"grid justify-center items-center h-screen"}><img className={'w-20'} src={loader} alt={'Loader'} /></div>
        : state.error ? <h4>Fel uppstod!</h4>
        : null}
    </div>
  );
};

export default LoadingView;
